<template>
    <div class="registration scrollable-div">
        <div class="container-fluid">
            <div class="row content">
                <div class="col align-self-center">
                    <Logo/>
                    <div class="d-flex flex-column justify-content-center text-center header">
                        <h2 class="mt-5">{{ $t('registration.reset_password_h2') }}</h2>
                    </div>
                    <div class="row main">
                        <div class="w-100 step-4">
                            <label class="font-weight-bold text-center w-100 mb-4" style="font-size: 24px;">
                                {{ $t('registration.create_password') }}
                            </label>
                            <div class="form-group merged w-100" :class="{ 'invalid': false}">
                                <label class="font-weight-bold d-block">
                                    {{ $t('registration.password') }}
                                </label>
                                <input id="password" type="password" class="w-100" v-model="password">
                                <div style="font-size: 12px;line-height: 15px;">
                                    <span class="required">* &nbsp;</span>{{ $t('registration.pass_length') }}
                                </div>
                            </div>
                            <div class="form-group merged w-100" :class="{ 'invalid': false}">
                                <label class="font-weight-bold d-block">
                                    {{ $t('registration.repeat_password') }}
                                </label>
                                <input id="password_confirmed" type="password" class="w-100"
                                       v-model="password_confirmed">

                            </div>
                            <button type="button" @click="resetPassword()" :disabled="$v.password_confirmed.$invalid ||
                            $v.password.$invalid || loading"
                                    class="btn btn-primary mt-5">
                                {{ $t('registration.save') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { minLength, required, sameAs } from 'vuelidate/lib/validators';
    import Logo from '../components/Logo';


    export default {
        name: 'reset-password',
        props: {
            token: {
                required: true,
                type: String,
            },
        },
        data() {
            return {
                password: null,
                password_confirmed: null,
            }
        },
        validations() {
            return {
                password: {
                    required,
                    minLength: minLength(8),

                },
                password_confirmed: {
                    required,
                    sameAsPassword: sameAs('password'),
                },
            };
        },
        methods: {
            resetPassword() {
                this.$store.dispatch('resetPassword', {
                    token: this.token,
                    new_password: this.password_confirmed,
                }).then(() => {
                    this.$router.push({ name: 'registration.success', params: { type: 'reset_password' } })
                }).catch(error => {
                    if (error.response.data.code === 'reset-password-token-expired-exception') {
                        this.$router.push({ name: 'password.forgot' })
                    }
                })
            }
        },
        components: {
            Logo,
        },
        beforeMount() {
            this.$i18n.locale = 'ua';
        }
    }
</script>
